import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { GlobalMenuGroupsRouteNames, GlobalMenuGroupsRoutePathNames } from '../../../../enums';

const Component = () => import('./ActiveBrands.vue');

export default {
  path: buildChildURL(GlobalMenuGroupsRoutePathNames.ACTIVE_BRANDS),
  name: GlobalMenuGroupsRouteNames.ACTIVE_BRANDS,
  component: Component,
} as RouteRecordRaw;
